if (!String.prototype.endsWith) {
  // eslint-disable-next-line no-extend-native
  String.prototype.endsWith = function (searchStr, position) {
    if (
      typeof position === 'undefined' ||
      isNaN(position) ||
      position >= this.length
    ) {
      position = this.length
    } else {
      position = Math.floor(position)
    }

    return (
      this.substr(position - searchStr.length, searchStr.length) === searchStr
    )
  }
}
